module.exports = __webpack_public_path__ + "static/media/1.dde30784.JPG";